import { QueryClient } from '@tanstack/react-query'
// import { showToaster } from '../toaster/helper'

export const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      onError: (e) => {
        // showToaster({ msg: e?.sMessage || e?.message, eType: 'e' })
      }
    },
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      select: (data) => {
        return data?.data || data
      },
      onError: (e) => {
        // showToaster({ msg: e?.sMessage || e?.message, eType: 'e' })
      },
      staleTime: 60 * 1000
    }
  }
})
